import { Dispatch, SetStateAction } from "react";

export default function HamburgerButton({
	isActiveHamburgerButton,
	setIsActiveHamburgerButton,
}: {
	isActiveHamburgerButton: boolean;
	setIsActiveHamburgerButton: Dispatch<SetStateAction<boolean>>;
}) {
	const handleClick = () => {
		setIsActiveHamburgerButton(!isActiveHamburgerButton);
	};

	return (
		<section
			className={`flex md:hidden justify-center items-center fixed top-7 right-7 !z-1100 w-[30px] h-[30px] cursor-pointer transition-all duration-500`}
			onClick={handleClick}
			tabIndex={0}
		>
			<div
				className={`bg-[#15005a] rounded-lg absolute h-[10%] w-[75%] top-[18%] transition-all duration-500 ${
					isActiveHamburgerButton
						? "top-[28%] translate-y-[165%] rotate-45 w-[50%]"
						: ""
				}`}
			/>
			<div
				className={`bg-[#15005a] rounded-lg absolute h-[10%] w-[75%] top-1/2 -translate-y-1/2 transition-all duration-500 ${
					isActiveHamburgerButton ? "opacity-0 w-0" : ""
				}`}
			/>
			<div
				className={`bg-[#15005a] rounded-lg absolute h-[10%] w-[75%] bottom-[18%] transition-all duration-500 ${
					isActiveHamburgerButton
						? "translate-y-[-280%] -rotate-45 w-[50%]"
						: ""
				}`}
			/>
		</section>
	);
}
